import type {PaymentCard} from '@yandex-delivery/api/model/payment'
import {isPrimaryPhoneEmpty, isUnAuthenticated} from '@yandex-delivery/api/repo/cargo-corp/getters/launch'
import {constant, firstOf, ifThen, isEmpty} from '@yandex-delivery/utils'

import {fetchBoundedCard} from 'src/shared/api'
import type {LaunchResponse} from 'src/shared/api/cargo-corp'
import {UnannouncedError} from 'src/shared/components/HandleError'
import {appConfig} from 'src/shared/config'

type CardRequest = {
  onSuccess(card: PaymentCard): void | Promise<void>
}
type CardResponse = ReturnType<typeof fetchBoundedCard>

export const enum CardErrorCode {
  UNAUTHORIZED = 'unauthorized',
  EMPTY_LOGIN = 'empty_login',
  EMPTY_PHONE = 'empty_phone',
}

const getUnauthorizedMessage: (r?: LaunchResponse) => CardErrorCode | undefined = firstOf(
  ifThen(isEmpty, constant(CardErrorCode.UNAUTHORIZED)),
  ifThen(isUnAuthenticated, constant(CardErrorCode.UNAUTHORIZED)),
  ifThen(isPrimaryPhoneEmpty, constant(CardErrorCode.EMPTY_PHONE)),
)

export async function fetchCard({onSuccess}: CardRequest): CardResponse {
  const unauthorizedMessage = getUnauthorizedMessage(appConfig.launch)

  // если ланч пустой, значит пользователь не авторизован и смысла в походе в бекенд нет
  if (unauthorizedMessage) {
    throw new UnannouncedError(unauthorizedMessage)
  }

  const boundedCard = await fetchBoundedCard(appConfig.countryCode)

  if (boundedCard) {
    await onSuccess(boundedCard)
  }

  return boundedCard
}
